import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/DriverSettingTypeSlice';
import NotificationHandler from 'utils/notification';
import { driverSettingTypeApi } from '../../../api/index';
const getSearchCriteria = (state) => state.driverSettingType.searchCriteria;
function* getDriverSettingList({ payload: { params } }) {
    try {
        const { getDriverSettingType } = driverSettingTypeApi;
        const response = yield getDriverSettingType({ params });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* createDriverSettingType({ payload: { params, callBackFunction } }) {
    try {
        const { createDriverSettingType } = driverSettingTypeApi;

        const response = yield createDriverSettingType({ params });
        if (response) {
            if (params?.id) {
                NotificationHandler.notifySuccess('Sửa thành công!');
                if (callBackFunction) {
                    callBackFunction({ id: params?.id });
                }
            } else {
                NotificationHandler.notifySuccess('Thêm thành công!');
                if (callBackFunction) {
                    callBackFunction();
                }
            }
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        }
    } catch (error) {
        if (callBackFunction) {
            callBackFunction({ error: error });
        }
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.create_driver_setting_type_failed.type, payload: error });
    }
}

function* deleteDriverSettingType({ payload: { params, callBackFunction } }) {
    try {
        const { deleteDriverSettingType } = driverSettingTypeApi;

        const response = yield deleteDriverSettingType({ params });
        if (response) {
            NotificationHandler.notifySuccess('Xóa thành công!');
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
            yield put({ type: listActions.delete_driver_setting_type_success.type });
            if (callBackFunction) {
                callBackFunction();
            }
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.delete_driver_setting_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getDriverSettingList);
    yield takeLatest(listActions.create_driver_setting_type.type, createDriverSettingType);
    yield takeLatest(listActions.delete_driver_setting_type.type, deleteDriverSettingType);
}

export default watchRequestDetail;
